export default "__VITE_ASSET__ef41453b__"